module.exports = __webpack_public_path__ + "2955e07f7ae77b023d4c8570c3e01c49.svg";